import {CollectionDataWithProductsFragment} from '../../lib/generated';
import {getCollectionByHandle, getCollectionHandles, getCollections} from '../../utils/shop_backend';
import {GetStaticProps} from 'next';
import React, {useState} from 'react';
import {AspectRatio, Badge, Box, Heading, HStack, SimpleGrid, Text, VStack} from '@chakra-ui/react';
import Link from 'next/link';
import NextImage from 'next/image';
import {formatCurrencyString} from '../../utils/shopping-cart';
import {NextSeo} from 'next-seo';
import {shopifyImageLoader} from '../../utils/image-loader';
import {ProductData} from '../../json-ld/product';

// @ts-ignore collections prop used for header
const CollectionPage = ({collection, collections}: { collection: CollectionDataWithProductsFragment }) => {
    const [currentHover, setCurrentHover] = useState<string>('');

    return <>
        <NextSeo
            title={collection.title + ' - Blickfang'}
            openGraph={{
                type: 'website',
                locale: 'de_DE',
                title: collection.title + ' - Blickfang',
                images: [{url: collection.image?.url}],
            }}
            twitter={{
                cardType: 'summary_large_image',
            }}
        />
        <Box pb={'40px'}>
            <Heading w={'100%'} textAlign={'center'} pt={'20px'}>{collection.title}</Heading>
            <SimpleGrid columns={{sm: 2, md: 3}} p={'10px'} w={'100%'} spacing="10px">
                {collection.products.edges.map((edge, index) => {
                    const product = edge.node;
                    return <Link href={'/items/' + product.handle} key={product.id}><VStack cursor={'pointer'}
                                                                                            overflow={'hidden'}
                                                                                            spacing={'10px'}
                                                                                            justify={'space-between'}
                                                                                            maxH={'80vh'}>
                        <AspectRatio onMouseOver={() => setCurrentHover(product.id)}
                                     onMouseOut={() => setCurrentHover('')} ratio={0.6} w={['90vw', '100%']}
                                     overflow={'hidden'}>
                            <>
                                <NextImage
                                    loader={shopifyImageLoader}
                                    src={product.images.edges[0].node.url}
                                    fill
                                    sizes="(max-width: 460px) 90vw, 30vw"
                                    quality={'60'}
                                    priority={index === 0}
                                    style={{
                                        objectFit: 'cover',
                                        objectPosition: 'center',
                                        //display: currentHover === product.id ? 'none' : 'block',
                                    }}
                                    alt={product.images.edges[0].node.altText ?? ''}
                                />
                                <NextImage
                                    loader={shopifyImageLoader}
                                    src={product.images.edges[product.images.edges.length - 1].node.url}
                                    fill
                                    sizes="(max-width: 460px) 90vw, 30vw"
                                    quality={'60'}
                                    style={{
                                        objectFit: 'cover',
                                        objectPosition: 'center',
                                        opacity: currentHover === product.id ? '1' : '0',
                                        transition: 'opacity 0.3s',
                                    }}
                                    alt={product.images.edges[product.images.edges.length - 1].node.altText ?? ''}
                                />
                            </>
                        </AspectRatio>
                        <Box pl={'3px'} w={['90vw', '100%']}>
                            <Heading pt={'10px'} size={'md'} m={0} w={'100%'}>{product.title}</Heading>
                            <HStack w={'100%'} mb={'20px'} spacing={'4'}>
                                <Text
                                    color={'gray.400'}><b>{formatCurrencyString(product.variants.edges[0].node.priceV2.amount)}*</b></Text>
                                {!edge.node.availableForSale && <Badge variant="outline">Ausverkauft</Badge>}
                            </HStack>
                        </Box>
                    </VStack>
                        <ProductData product={product}/>
                    </Link>;

                })}
            </SimpleGrid>
        </Box></>
}

export default CollectionPage

export const getStaticProps: GetStaticProps = async (context) => {
    const collections = await getCollections();


    const collection_handle: string = context?.params?.collection_handle as string;
    const collection = await getCollectionByHandle(collection_handle);

    if (!collection) return {
        props: {
            collections,
        },
        notFound: true,
    };


    return {
        props: {
            collection,
            collections,
        },
        revalidate: 60,
    }
}

export const getStaticPaths = async () => {
    return {
        paths:
            (await getCollectionHandles())?.map(handle => {
                return {'params': {'collection_handle': handle}};
            }),
        fallback: 'blocking',
    };
};
